import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import TableSettingsDrawerContent, {
  TableSettingsDrawerProps,
} from "ds/components/Table/Settings/DrawerContent";

import { TableSimpleStore } from "./types";

type TableSimpleSettingsDrawerProps = {
  store: TableSimpleStore;
} & Pick<TableSettingsDrawerProps, "trackAnalytics" | "title">;

const TableSimpleSettingsDrawer = createDrawer(
  ({ store, trackAnalytics, title }: TableSimpleSettingsDrawerProps) => {
    return (
      <TableSettingsDrawerContent store={store} trackAnalytics={trackAnalytics} title={title} />
    );
  }
);

export const showTableSimpleSettingsDrawer = createDrawerTrigger(TableSimpleSettingsDrawer);
